var styles = {"Anchor":"feBFPyem0vg-","Container":"_5-yE5oWUWPs-","Tooltip":"_-1XZXRLzwUw-"};

export { styles as default };
//# sourceMappingURL=Tooltip.module.css.js.map
